import { Content, HeaderSimple } from '@angeplus/prever-component-lib';
import { ReactNode } from 'react';

type TemplateProps = {
  children: ReactNode;
  title: string;
};

export const PageTemplate = (props: TemplateProps) => {
  return (
    <Content>
      <HeaderSimple>{props.title}</HeaderSimple>
      {props.children}
    </Content>
  );
};
